import InsightsPanel from './InsightsPanel';

export { type InsightsPanelProps } from './InsightsPanel';
export default InsightsPanel;
